import styled from 'styled-components';

const Button = styled.button`
  height: ${(props) => (props.small ? '38px' : '48px')};
  height: ${(props) => props.buttonHeight};
  min-width: ${(props) => (props.small ? '114px' : '280px')};
  min-width: ${(props) => props.buttonWidth};
  color: ${(props) =>
    props.disabled
      ? props.theme.primaryButtonDisabledFontColor
      : props.theme.primaryButtonFontColor};
  background: ${(props) =>
    props.disabled
      ? props.theme.primaryButtonDisabledColor
      : props.theme.primaryButtonBackgroundColor};
  text-transform: ${(props) => props.theme.primaryButtonTextTransform};
  border-radius: ${(props) => props.theme.primaryButtonBorderRadius};
  // box-shadow: ${(props) => props.theme.primaryButtonBoxShadow};
  font-size: ${(props) => (props.small ? '14px' : '20px')};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${(props) =>
    props.buttonBorderRadius ? props.buttonBorderRadius : '4px'};
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  font-weight: ${(props) => props.fontWeight};
  &:hover {
    background: ${(props) =>
      !props.disabled && props.theme.primaryButtonHoverColor};
    color: ${(props) =>
      props.disabled
        ? props.theme.primaryButtonDisabledFontColor
        : props.theme.primaryButtonTextHoverColor};
    transition: all 0.25s ease;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default Button;
